import { ref } from "vue";
import GridParametros from "./GridParametros";
import { reactive } from "vue";
import { isArray } from "lodash";

function converterEnumParaTexto(value, enumPropsArray){
    let textoResultado
    enumPropsArray.forEach(obj => {
        if(obj.value === value){
            textoResultado = obj.text
        }
    });
    return textoResultado
}

function validaEmail(email = ''){
    // eslint-disable-next-line
    let validacaoEmailNFE = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return validacaoEmailNFE.exec(email);
}

function validaVariavelPreenchida(variavel){
    return ['', undefined, null, [], {}, 0, '0'].includes(variavel);
}

function validaCNPJ (cnpj = '') {
    var cnpjFiltrado = cnpj.replace(/[^\d]+/g,'');

    if(!cnpjFiltrado) return false;

    if (cnpjFiltrado.length != 14) return false;

    let cnpjsInvalidosConhecidos = [
        '00000000000000',
        '11111111111111',
        '22222222222222',
        '33333333333333',
        '44444444444444',
        '55555555555555',
        '66666666666666',
        '77777777777777',
        '88888888888888',
        '99999999999999',
    ]

    // Elimina CNPJs invalidos conhecidos
    if (cnpjsInvalidosConhecidos.includes(cnpjFiltrado)) return false;

    // Valida DVs
    var tamanho = cnpjFiltrado.length - 2
    var numeros = cnpjFiltrado.substring(0,tamanho);
    var digitos = cnpjFiltrado.substring(tamanho);
    var soma = 0;
    var pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
            pos = 9;
    }
    var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0))
        return false;

    tamanho = tamanho + 1;
    numeros = cnpjFiltrado.substring(0,tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1))
          return false;

    return true;
}

function converterTextoParaEnum(text,enumPropsArray){
    let enumResultado
    enumPropsArray.forEach(obj => {
        if(obj.text === text){
           enumResultado = obj.value
        }
    });
    return enumResultado
}

function objectCustomAssign (alvo, origem) {
    Object.keys({...alvo}).forEach(chave => {
        if(!(alvo[chave] !== undefined && origem[chave] === undefined)){
            alvo[chave] = origem[chave]
        }
    })
}

function captalizeKeys(objOriginal){
    let objConvertido = {}
    for (var chave in objOriginal){
        objConvertido[chave.charAt(0).toUpperCase() + chave.substring(1)] = objOriginal[chave]
    }
    return objConvertido;
}

function formatarDados(data,novoValor){
    //formatar objeto entrada de dados para exibição  e retornar novoValor para não quebrar o back
    Object.keys(data).forEach((valor)=>{
      if(!data[valor]){
        data[valor] = novoValor
      }
   })
   return data
}

export const retornaDataNormalizada = (data = new Date()) => {
    const parametrosFormatacao = { minimumIntegerDigits: 2, useGrouping: false  }
    return `${data.getDate().toLocaleString('pt-BR', parametrosFormatacao)}-${(data.getMonth() + 1).toLocaleString('pt-BR', parametrosFormatacao)}-${data.getFullYear()}`
  }


//   export const toast = (tipo, titulo, texto, tempo = 2500) => {
//     if(!['error', 'warn', 'info', 'success'].includes(tipo)){
//       console.warn(`O tipo "${tipo}" não é valido para Toasts. Tipo trocado para "info"`)
//       tipo = 'info'
//     }
//     appToast.add({
//       severity: tipo,    
//       summary: titulo,
//       detail: texto,
//       life: tempo,
//     })
//   }


export const propriedadesGrid = {
    busca: {
      type: Number,
      default: 0,
    },
    parametros: {
      type: GridParametros,
      default: new GridParametros(),
    },
  }

  export const useGrid = (...args) => {
    let _filtros = ref([])
    args.forEach((a) =>
      _filtros.value.push({
        campo: a,
        valor: null,
      })
    )
  
    let busca = ref(0)
    function filtrar() {
      busca.value++
    }
  
    let a = new GridParametros()
    let _parametros = reactive(a)
  
    const limpar = () => {
      _filtros.value.forEach((x) => {
        if (isArray(x.valor)) x.valor = []
        else x.valor = null
      })
      _parametros.Filtros = _filtros
      busca.value++
    }
  
    return {
      filtros: _filtros.value,
      busca,
      parametros: _parametros,
      limpar: limpar,
      filtrar: filtrar,
    }
  }


  export const valorMonetario = (valorNaoFormatado) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(valorNaoFormatado)
  }

  const valorMonetario4Digitos = (valor)  =>{
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 4
    }).format(valor)
  }

  const valorDecimalFormatado = (valor) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'decimal'
    }).format(valor)
  }


  export const desformata = (valor) => {
    return valor.replace(/[\D]/gm, '')
  }

const Tools = {
    converterEnumParaTexto,
    validaCNPJ,
    validaVariavelPreenchida,
    validaEmail,
    converterTextoParaEnum,
    objectCustomAssign,
    formatarDados,
    captalizeKeys,
    valorMonetario4Digitos,
    valorDecimalFormatado
}

export default Tools